<template>
    <tr class="user-selectable"
        data-component="MellonWebECRTransactionRow">
        <!-- Created At -->
        <td>
            {{ timeFilter(intent.Timestamp, false, true) }}

            <small v-if="intent.CustomerReference"
                   class="block">{{ intent.CustomerReference }}</small>
        </td>

        <!-- Amount -->
        <td>
            {{ currencyFilter(fromMinorUnit(intent.Amount)) }}
        </td>

        <!-- Status -->
        <td>
            <MellonWebECRSimpleStatusLabel :intent="intent"
                                           :transaction="transaction" />
            <small v-if="transaction?.AuthCode"
                   class="block">
                {{ transaction.AuthCode }}
            </small>
        </td>

        <!-- Card Number -->
        <td>
            {{ transaction?.CardPAN }}
        </td>

        <!-- Actions -->
        <td class="text-right">
            <SquareBtn v-if="voidable"
                       color="danger"
                       :loading="voiding === true"
                       :disabled="voiding === false"
                       @click="$emit('void', { intent, transaction })">
                <i class="fa-solid fa-ban"></i>
                {{ l('PAYMENT.VOID_BTN') }}
            </SquareBtn>

            <span v-if="payment"
                  class="label label-default">
                Payment ID: {{ payment.paymentID }}
            </span>
        </td>
    </tr>
</template>

<script>
import MellonWebECRSimpleStatusLabel
    from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRSimpleStatusLabel';
import SquareBtn from '@/vue/components/SquareBtn';
import { currencyFilter } from '@/vue/filters/currencyFilter';
import { fromMinorUnit } from '@/functions/math';
import { timeFilter } from '@/vue/filters/timeFilter';

export default {
    components: {
        MellonWebECRSimpleStatusLabel,
        SquareBtn,
    },

    props: {
        /**
         * @type {MellonWebECRTransactionIntent}
         */
        intent: {
            type: Object,
            required: true,
        },

        /**
         * @type {?MellonWebECRTransaction}
         */
        transaction: {
            type: Object,
            default: null,
        },

        payment: {
            type: Object,
            default: null,
        },

        /**
         * null if no transaction is being voided
         * true if *this* transaction is being voided
         * false if *another* transaction is being voided
         *
         * @type {?boolean}
         */
        voiding: {
            type: Boolean,
            default: null,
        },
    },

    emits: ['void'],

    computed: {
        voidable() {
            return !this.payment
                && this.transaction?.Approved
                && !this.transaction?.Voided;
        },
    },

    methods: {
        currencyFilter,
        fromMinorUnit,
        timeFilter,
    },
};
</script>
